export default __webpack_public_path__ + "static/media/jolt-65-2.6a0f56bf.jpg";